<template>
  <div>
    <el-table
      :data="campaigns"
      :highlight-current-row="true"
      @row-click="openTrackTable"
    >
      <el-table-column label="Name" prop="name"></el-table-column>
      <!-- <el-table-column
        label="VC Balance"
        prop="balance"
      >
      </el-table-column> -->
      <el-table-column label="Track" align="left"></el-table-column>
      <el-table-column label="Status" align="center"></el-table-column>
      <el-table-column label="Budget" align="center"></el-table-column>
      <el-table-column label="Balance" align="center"></el-table-column>
      <el-table-column label="Starting" align="center">
        <template slot-scope="props">
          {{ props.row.created_at | date }}
        </template>
      </el-table-column>
      <el-table-column label="Ending" align="center">
        <template slot-scope="props">
          {{ props.row.ending_at | date }}
        </template>
      </el-table-column>
      <!-- <el-table-column label="Updated at">
        <template slot-scope="props">
          {{ props.row.updated_at | date }}
        </template>
      </el-table-column> -->
      <el-table-column label="Actions" align="center">
        <template slot-scope="props">
          <!-- <el-tooltip content="Deposit" placement="top">
            <el-button class="deposit-btn"
              circle
              size="small"
              @click="openDeposit(props.row)"
            >$</el-button>
          </el-tooltip>
          <el-tooltip content="Insert track" placement="top">
            <el-button class="download-btn"
              circle
              size="small"
              icon="el-icon-download"
              @click="openTrackDialog(props.row)"
            ></el-button>
          </el-tooltip> -->
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex'

export default {
  computed: {
    ...mapState('labelVidCents', ['campaigns']),
    ...mapState('labelTrackVidCents', ['active_campaign'])
  },

  watch: {
    active_campaign(){
      this.$refs.campaignTable.setCurrentRow(this.active_campaign)  
    }
  },

  methods: {
    ...mapActions('labelTrackVidCents', ['readTracks']),
    ...mapMutations('labelVidCents', ['setCampaign', 'setCampaignDeposit']),
    ...mapMutations('labelTrackVidCents', [
      'setActiveCampaign',
      'setTrackDialog'
    ]),

    openDeposit(row) {
      this.setCampaignDeposit(true)
      this.setCampaign(row)
    },
    openTrackTable(row) {
      this.setActiveCampaign(row)
      this.readTracks()
    },
    openTrackDialog(row) {
      this.setActiveCampaign(row)
      this.setTrackDialog(true)
    }
  }
}
</script>
